<template>
  <div class="login-frame full">
    <div class="login-container">
      <div class="container-wrap">
        <login-head></login-head>
        <login-main></login-main>
      </div>
      <login-foot></login-foot>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { LoginHead, LoginMain, LoginFoot } from './index'

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title
    }
  },
  data () {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  components: {
    LoginHead,
    LoginMain,
    LoginFoot
  }
}
</script>

<style lang="stylus">
@import './main'
.cube-btn {
  display: block;
  margin: 0;
  padding: 17px 16px;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  color: #fff;
  background: #fc724c;
  outline: none;
  border: none;
  border-radius: 2px;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
}
</style>
